import React, { Component } from 'react';

import IconButton from '@material-ui/core/IconButton';
import IconCheckBoxChecked from '@material-ui/icons/CheckBox';
import IconCheckBoxOutline from '@material-ui/icons/CheckBoxOutlineBlank';
import IconCheckBoxWrong from '@material-ui/icons/IndeterminateCheckBox';

import classes from './AnswerIcon.css';

class AnswerIcon extends Component {

	state = {
		checked:0
	}

	componentWillReceiveProps (nextProps) {
		if (nextProps.iconType===0) {
			this.setState({
				checked:0
			});
		}
	}

	prepareForClick = () => {
		if (this.props.disabled) return;
		let newChecked;
		if (this.state.checked!==2) {
			newChecked = 2;
		} else {
			newChecked = 1;
		}
		this.setState({
			checked: newChecked
		})
		this.props.doClick(this.props.correctness,this.props.order);
	}

	render () {
		let icotype=<IconCheckBoxOutline/>;
		let cls = "button";

		if (this.state.checked===2) {
			if (this.props.correctness===true) {
				icotype = <IconCheckBoxChecked/>
				cls = "green";
			} else {
				icotype = <IconCheckBoxWrong/>
				cls = "red";
			}
		}

		return (
			<div className={classes.singleAnswer} onClick={this.prepareForClick}>
				<IconButton 
					className={classes[cls]}

				>
					{icotype}
				</IconButton>
				<div className={classes.answerLabel}>
					{this.props.answerText}
				</div>
			</div>
		);
	}
};

export default AnswerIcon;


// WEBPACK FOOTER //
// ./src/components/AnswerIcon/AnswerIcon.js